export interface AppArtifactBuilderSkillInstruction {
  client: 'ChatGPT' | 'Codex' | 'Claude Code' | 'Claude.ai'
  text: string
}

export interface AppArtifactBuilderSkillMetadata {
  id: string
  name: string
  description: string
  version: string
  fileName: string
  downloadPath: string
  instructions: AppArtifactBuilderSkillInstruction[]
}

type FetchLike = (input: string, init?: RequestInit) => Promise<Response>

export async function fetchAppArtifactBuilderSkill(
  apiBaseUrl: string,
  fetchImpl: FetchLike = fetch,
): Promise<AppArtifactBuilderSkillMetadata> {
  const response = await fetchImpl(`${apiBaseUrl}/api/r3/app-artifact-builder-skill`, {
    credentials: 'include',
    cache: 'no-store',
  })
  if (!response.ok) throw new Error(`Could not load App Artifact Builder (${response.status})`)
  return response.json() as Promise<AppArtifactBuilderSkillMetadata>
}

export async function fetchAppArtifactBuilderSkillZip(
  apiBaseUrl: string,
  fallbackFileName: string,
  fetchImpl: FetchLike = fetch,
): Promise<{blob: Blob; fileName: string}> {
  const response = await fetchImpl(`${apiBaseUrl}/api/r3/app-artifact-builder-skill/download`, {
    credentials: 'include',
  })
  if (!response.ok) throw new Error(`Could not download App Artifact Builder (${response.status})`)
  const disposition = response.headers.get('Content-Disposition') ?? ''
  const match = disposition.match(/filename="?([^";]+)"?/i)
  return {
    blob: await response.blob(),
    fileName: match?.[1] || fallbackFileName,
  }
}
